import { TResponse } from "./tresponse";
import { LazyParams } from "./lazyParams";
import { ApiLoginResponse } from "../Models/loginModels";
import api, { Axios } from "../axiosApi";

export class MobiTheraService {
  async consultantLogin(requestBody: any): Promise<ApiLoginResponse> {
    const consultantLoginResponse = await api.post(`/Keycloak/login`, requestBody)
    const consultantLoginData = consultantLoginResponse.data;

    localStorage.setItem('account', JSON.stringify(consultantLoginData.userInfo))

    Axios.setTokens(consultantLoginData.token.accessToken, consultantLoginData.token.refreshToken)

    return consultantLoginData;
  }

  async consultantRegister(requestBody: any): Promise<any> {
    const consultantRegisterResponse = await api.post(`/SignUpRequests/Create`, requestBody)
    const consultantRegisterData = consultantRegisterResponse.data;

    return consultantRegisterData
  }

  async tokenCheckWithRefreshToken(): Promise<any> {
    Axios.setRefreshToken(Axios.getRefreshToken())
    Axios.setAuthToken(Axios.getAuthToken())
    const tokenCheckResponse = await api.post("/Keycloak/refresh-token", JSON.stringify(Axios.getRefreshToken()), { headers: { "Content-Type": "application/json" } });
    Axios.setTokens(tokenCheckResponse.data.accessToken, tokenCheckResponse.data.refreshToken)
    return tokenCheckResponse.data;
  }

  async consultantSignout(refreshToken: string): Promise<any> {
    const result = await api.get(`/Keycloak/logout?refreshToken=${refreshToken}`)
    return result.data;
  }

  async consultantGetCalismaSonuc(requestBody: any): Promise<any> {
    const result = await api.post(`/Consultant/GetCalismaSonuc`, requestBody)
    return result.data;
  }

  async consultantGetTahsilSonuc(requestBody: any): Promise<any> {
    const result = await api.post(`/Consultant/GetTahsilSonuc`, requestBody)
    return result.data;
  }

  async consultantGetUshHizmetiSonuc(requestBody: any): Promise<any> {
    const result = await api.post(`/Consultant/GetUshHizmetiSonuc`, requestBody)
    return result.data;
  }

  async getPatientNewList(lazyParamsForPatientNewList: LazyParams): Promise<TResponse<any[]>> {
    return (await api.post("/PatientNew/GetAll", lazyParamsForPatientNewList)).data;
  }

  async getPatientList(lazyParamsForPatientList: LazyParams): Promise<TResponse<any[]>> {
    return (await api.post("/Patient/GetAll", lazyParamsForPatientList)).data;
  }

  async getPatien(patientId: any): Promise<TResponse<any>> {
    return (await api.get("/Patient/GetByPatientId", {
      params: { id: patientId }
    })).data;
  }

  async addPatientToList(patient: any): Promise<any> {
    const patientCode = (await api.post("/PatientNew/Add", patient)).data;
    return patientCode
  }

  async updatePatient(patient: any): Promise<any> {
    return (await api.post("/Patient/Update", patient)).data;
  }

  async deleteNewPatient(patientId: any): Promise<any> {
    return (await api.post("/PatientNew/Delete", { id: patientId })).data;
  }

  async getOngoingPlanListForToday(): Promise<TResponse<any[]>> {
    return (await api.get("PlanDetails/TodayDashboardPlanList")).data;
  }

  async getGeneralOngoingPlanList(): Promise<TResponse<any[]>> {
    return (await api.post("Plan/DashboardPlanList",
      {
        dateStarted: null,
        dateEnd: null
      }
    )).data;
  }

  async getStatusCountByConsultant(): Promise<any> {
    return (await api.get("PlanDetails/PlanStatusCountByConsultant")).data;
  }

  async getMonthlyStatus(): Promise<any> {
    return (await api.get("PlanDetails/GetMonthlyStatus")).data
  }

  async getCompletedPlanCounter(): Promise<any> {
    return (await api.get("Plan/CompletedPlanCounter")).data
  }

  async addPlan(plan: any): Promise<any> {
    return (await api.post("/Plan/Add", plan)).data;
  }

  async getPlanListById(patientAndPlanInfo: any): Promise<TResponse<any[]>> {
    const lang = localStorage.getItem("i18nextLng");
    const obj = {
      patientId: patientAndPlanInfo.patientId,
      status: patientAndPlanInfo.planTimeLine,
      limit: 100,
      offset: 0,
      startTime: patientAndPlanInfo.startTime ? patientAndPlanInfo.startTime : null,
      endTime: patientAndPlanInfo.endTime ? patientAndPlanInfo.endTime : null,
      language: lang
    }
    const planListData = (await api.post("/Plan/PlanListForPatinentPlanId", obj)).data;
    return planListData;
  }

  async getMyPanels(): Promise<TResponse<any[]>> {
    const lang = localStorage.getItem("i18nextLng");
    const panelList = (await api.post("/ConsultantPanel/GetAll", { language: lang })).data.data;
    return panelList;
  }

  async deleteFuturePlan(planId: any): Promise<TResponse<any[]>> {
    return (await api.post("/Plan/Delete", { id: planId })).data;
  }

  async saveMyPanel(panel: any): Promise<TResponse<any[]>> {
    const panelList = (await api.post("/ConsultantPanel/Add", panel)).data.data;
    return panelList
  }

  async deleteMyPanel(panelId: any): Promise<any> {
    await api.post("/ConsultantPanel/Delete", panelId);
  }

  async updateMyPanel(panel: any): Promise<any> {
    return (await api.post("/ConsultantPanel/Update", panel)).data.data;
  }

  async getSystemProcedures(): Promise<any> {
    const lang = localStorage.getItem("i18nextLng");
    return (await api.post("/SystemProcedure/GetAll", { rows: 100, filters: { name: { value: "" } }, language: lang })).data.data
  }

  async getAppointmentList(lazyParamsForAppointments: LazyParams): Promise<TResponse<any[]>> {
    const appointmentData = (await api.post("/Appointment/GetAllCSR")).data;
    appointmentData["totalRecords"] = appointmentData?.totalCount;

    return appointmentData;
  }

  async updateAppointmentStatus(appointment: any): Promise<any> {
    await api.post("/Appointment/UpdateStatus", appointment);
  }

  async getExercisesList(lazyParamsForExercises: LazyParams): Promise<TResponse<any[]>> {
    const lang = localStorage.getItem("i18nextLng");

    const params = {
      ...lazyParamsForExercises,
      filters: {
        ...lazyParamsForExercises.filters,
      },
      language: lang
    }

    const exercisesList = (await api.post("/ExerciseProcedure/GetAll", params)).data.data;
    exercisesList["totalRecords"] = exercisesList?.count;
    return exercisesList;
  }

  async getAccessCode(patientId: any): Promise<any> {
    const result = await api.post(`/AccessCodes/GetAccessCodes`, patientId)
    return result.data;
  }

  async submitAccessCode(patientObject: any): Promise<any> {
    const result = await api.post(`/AccessCodes/VerifyAccessCodes`, patientObject)
    return result.data;
  }

  async favoriteExercise(obj: any): Promise<any> {
    const result = await api.post(`/FavoriteExercises/Toggle`, obj);
    return result.data;
  }

  async getVisitNotes(patientId: any): Promise<any> {
    const result = await api.post(`Visit/GetListByPatientId`, {
      rows: 100,
      page: 0,
      sortField: "visitDate",
      sortOrder: -1,
      patientId: patientId
    })
    return result.data;
  }

  async addVisitNote(visitNote: any): Promise<any> {
    const result = await api.post(`Visit/Add`, visitNote)
    return result.data;
  }

  async updateVisitNote(visitNote: any): Promise<any> {
    const result = await api.post(`Visit/Update`, visitNote)
    return result.data;
  }

  async addDoctorNote(credentials: any): Promise<any> {
    const result = await api.post(`DoctorNotes/Add`, credentials);
    return result.data;
  }

  async getDoctorNotes(patientId: any): Promise<any> {
    const result = await api.post(`DoctorNotes/GetListByPatientId`, {
      rows: 100,
      page: 0,
      sortField: "date",
      sortOrder: -1,
      patientId: patientId
    })
    return result.data;
  }

  async updateDoctorNote(credentials: any): Promise<any> {
    const result = await api.post(`DoctorNotes/Update`, credentials);
    return result.data;
  }

  async deleteDoctorNote(credentials: any): Promise<any> {
    const result = await api.post(`DoctorNotes/Delete`, credentials);
    return result.data;
  }

  async getTreatmentCodeList(): Promise<any> {
    const result = await api.post(`TreatmentCodes/GetAll`, {
      rows: 1000,
      page: 0,
      sortField: "visitDate",
      sortOrder: -1,
    })
    return result.data;
  }

  async sendResetPasswordEmail(email: any): Promise<any> {
    const result = await api.post(`/Keycloak/forgot-password`, email);
    return result.data;
  }

  async resetPassword(credentials: any): Promise<any> {
    const result = await api.post(`/Keycloak/reset-forgotten-password`, credentials);
    return result.data;
  }

  async getEmergencyStopDataList(): Promise<any> {
    return (await api.get("EmergencyStopped/Get")).data
  }

  async markEmergencyItemAsSeen(id: any): Promise<any> {
    await api.post(`/EmergencyStopped/MarkAsRead`, { emergencyStopId: id });

  }

  async consultantPasswordCreation(credentials: any): Promise<any> {
    const result = await api.post(`/Keycloak/create-consultant-password/${credentials.token}`, credentials);
    return result.data;
  }

}
